<template>
    <div class="appShell">
        <RouterView />
    </div>
</template>

<script>
export default {
    name: 'App',

    computed: {

    },
}
</script>

<style lang="scss" scoped>

</style>
